import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getCourseAssignmentTeamSummaries as getCourseAssignmentTeamSummariesFromMonolith } from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

export type { TeamSummary, SortDirection } from '~/monolith-api';

const getCourseAssignmentTeamSummariesSchema = z.object({
   orderby: z.enum(['name']).optional(),
   direction: z.enum(['ASC', 'DESC']).optional(),
   page: z.number().optional(),
   pageSize: z.number().optional(),
   query: z.string().optional(),
   hideEmptyTeams: z.boolean().optional(),
});

export type GetCourseAssignmentTeamSummariesOptions = z.infer<
   typeof getCourseAssignmentTeamSummariesSchema
>;

export async function getCourseAssignmentTeamSummaries(
   options: GetCourseAssignmentTeamSummariesOptions & CommonRequestOptions
) {
   return await getCourseAssignmentTeamSummariesFromMonolith(options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const options = getCourseAssignmentTeamSummariesSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getCourseAssignmentTeamSummaries({
         ...options,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getCourseAssignmentTeamSummariesFromClient = (
   options: GetCourseAssignmentTeamSummariesOptions
): ReturnType<typeof getCourseAssignmentTeamSummaries> => {
   return bff()
      .post('/courses/manage/people/team-summaries/getCourseAssignmentTeamSummaries', {
         ...options,
      })
      .then(response => response.data);
};
